<template>
  <div>
    <div class="row1">
      <div>
        <el-button
          @click="onDel"
          class="row-btn del"
          type="primary"
          size="small"
          >作废</el-button
        >
		<el-button
		  @click="zydialogVisible = true"
		  class="row-btn add"
		  type="primary"
		  size="small"
		  >导入占用点位</el-button
		>
		<el-button
		  @click="kzdialogVisible = true"
		  class="row-btn add"
		  type="primary"
		  size="small"
		  >导入客户空置点位</el-button
		>
		<el-button
		  @click="handleDImg(0,6)"
		  class="row-btn add"
		  type="primary"
		  size="small"
		  >下载所有订单点位</el-button
		>
      </div>
      <div class="dis-flex alcenter">
        <div style="margin-right: 20px">
          <span style="font-size: 15px; margin-right: 6px">时间:</span>
          <el-date-picker
            v-model="value1"
            size="small"
            type="daterange"
			value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
			 @change="changeDate"
          >
          </el-date-picker>
        </div>
		<div class="" style="margin-left: 10px;">
			<span>品牌:</span>
			<el-input
			style="width: auto;margin: 0 15px 0 5px; "
			  size="small"
			  clearable
			  width="50"
			  placeholder="请输入品牌"
			  v-model="pageObj.brand"
			></el-input>
		 </div>
		 <div>
			 <div class="dis-flex alcenter">
			   <el-input
			     size="small"
			     clearable
			     placeholder="输入订单号搜索"
			     suffix-icon="el-icon-search"
			     v-model="searchVal"
			   >
			   </el-input>
			   <el-button
			     @click="onSearch"
			     class="row-btn add search"
			     type="primary"
			     size="small"
			     >搜索</el-button
			   >
			 </div>
		 </div>
      </div>
		 
    </div>
    <div class="tab-box">
      <el-table
        :span-method="arraySpanMethod"
        v-loading="loading"
        border
        element-loading-text="加载中"
        :header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"> </el-table-column>
        <!-- <el-table-column prop="name" label="投放画面"> </el-table-column> -->
        <el-table-column label="投放画面" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.flag" v-html="scope.row.name"></span>
            <el-image
			fit="cover"
			v-if="scope.row.flag && scope.row.imgList.length"
              style="width: 120px; height: 80px"
              :src="scope.row.imgList[0]"
              :preview-src-list="scope.row.images"
            >
            </el-image>
			<span v-if="scope.row.flag && !scope.row.imgList.length">
				未投放
			</span>
          </template>
        </el-table-column>

        <el-table-column label="客户名称"> 
			<template slot-scope="scope" v-if="scope.row.flag == 1">
				<span>{{scope.row.report?scope.row.report.name:''}}</span>
			</template>
		</el-table-column>
		<el-table-column prop="brand" label="品牌">
			<template slot-scope="scope" v-if="scope.row.flag == 1">
				<span>{{scope.row.report?scope.row.report.brand:''}}</span>
			</template>
		</el-table-column>
        <el-table-column prop="price" label="订单金额"> </el-table-column>
        <el-table-column prop="name3" label="是否支付" v-if="false">
			<template slot-scope="scope" v-if="scope.row.flag == 1">
				<span>{{scope.row.pay.text}}</span>
			</template>
		</el-table-column>
        <el-table-column label="广告位">
          <template slot-scope="scope" v-if="scope.row.flag == 1">
            <div v-for="(v,k) in scope.row.content.length > 3 ? 3 : scope.row.content.length" :key="k">
				{{scope.row.content[k].name}}
            </div>
            <div @click="lookAll(scope.row)" class="txt-btn txtC">查看更多</div>
			<div v-if="scope.row.is_switch == 1" @click="lookChangeP(scope.row)" class="txt-btn txtC">查看切换点位</div>
          </template>
        </el-table-column>
        <el-table-column prop="start_time" label="投放开始时间"> </el-table-column>
        <el-table-column prop="end_time" label="投放结束时间"> </el-table-column>
        <el-table-column prop="remark" label="备注"> </el-table-column>
        <el-table-column label="价审/锁位" v-if="false">
          <template slot-scope="scope" v-if="scope.row.flag">
			  <!--   0,价审,1锁位,2投放画面，3已投放   -->
            <span @click="jssw(scope.row,0,'确认订单')" class="txt-btn txtC" v-if="scope.row.order_status.value == 0">确认订单</span>
			<span @click="jssw(scope.row,1,'支付')" class="txt-btn txtC" v-if="scope.row.order_status.value == 1">支付</span>
			<span class="txt-btn" v-if="scope.row.order_status.value == 3">已投放画面</span>
          </template>
        </el-table-column>
		<el-table-column label="操作" width="150" align="center">
		  <template slot-scope="scope">
		    <div class="" v-if="scope.row.flag || scope.row.is_special == 0">
				<div v-if="scope.row.is_special == 0">
					<div>
					  <!-- <span v-if="scope.row.pay.value == 0"
						class="txt-btn txtC"
						@click="handlePay(scope.row)">支付</span> -->
					  <!-- <span v-else class="txt-btn">{{scope.row.pay.text}}</span> -->
					  <span @click="jssw(scope.row,0,'确认订单')" class="txt-btn txtC" v-if="scope.row.order_status.value == 0">确认订单</span>
					  <span @click="jssw(scope.row,1,`支付${scope.row.price}金额`)" class="txt-btn txtC" v-if="scope.row.order_status.value == 1">支付</span>
					  <span class="txt-btn" v-if="scope.row.order_status.value == 3">已投放画面</span>
					  <span @click="jssw(scope.row,2)" class="txt-btn txtC" 
					   v-if="scope.row.order_status.value == 2">投放画面</span>
					</div>
					<!-- <div v-if="scope.row.status.value > 0"> -->
					<div>
						<div @click="handleDImg(scope.row.id,1)" class="txt-btn txtC" style="margin: 6px 0;">下载上画照片</div>
						<div @click="handleDImg(scope.row.id,2)" class="txt-btn txtC">下载下画照片</div>
						<div @click="handleDImg(scope.row.id,3)" class="txt-btn txtC" 
						style="margin: 6px 0;" v-if="scope.row.remark &&  scope.row.pic_remark">下载上画单</div>
						<div v-if="scope.row.service_id>0" style="margin: 6px 0;" @click="handleDImg(scope.row.id,4)" class="txt-btn txtC">下载小样单</div>
						<div @click="handleDImg(scope.row.id,5)" class="txt-btn txtC">下载基础信息</div>
					</div>
				</div>
		    </div>
			
		  </template>
		</el-table-column>
        <!-- <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope" v-if="scope.$index % 2 == 1">
            <div class="handle-box">
              <span
                class="txt-btn txtC"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</span
              >
            </div>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页 -->
      <div class="page-box" v-if="tableData.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20, 30, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          >&emsp;
        </el-pagination>
		
      </div>
    </div>
	<!-- 占用点位 -->
	<el-dialog :destroy-on-close="true" :visible.sync="zydialogVisible" width="30%" :close-on-click-modal="false">
	  <div slot="title" class="title">导入占用点位</div>
	  <div class="dis-flex">
		  <div>
			  <el-upload
				class="upload-demo"
				:action="action2"
				:on-preview="handlePreview"
				:before-upload="beforeUpload"
				:on-remove="handleRemove"
				:before-remove="beforeRemove"
				multiple
				:limit="1"
				:on-exceed="handleExceed"
				:on-success="onSuccess"
				:file-list="fileList">
				<el-button size="small" type="primary">点击上传</el-button>
				<div slot="tip" class="el-upload__tip" style="color: red;">注意：只能上传xlsx文件!</div>
			  </el-upload>
		  </div>
		  <div><el-button size="small" type="success" @click="downLoadMode">下载导入模板</el-button></div>
	  </div>
	</el-dialog>
	<!-- 空置点位 -->
	<el-dialog :destroy-on-close="true" :visible.sync="kzdialogVisible" width="30%" :close-on-click-modal="false">
	  <div slot="title" class="title">导入空置点位</div>
	  <div class="dis-flex">
		  <div>
			  <el-upload
				class="upload-demo"
				:action="action3"
				:on-preview="handlePreview"
				:before-upload="beforeUpload"
				:on-remove="handleRemove"
				:before-remove="beforeRemove"
				multiple
				:limit="1"
				:on-exceed="handleExceed"
				:on-success="onSuccess"
				:on-progress="onProgress"
				:file-list="fileList">
				<el-button size="small" type="primary">点击上传</el-button>
				<div slot="tip" class="el-upload__tip" style="color: red;">注意：只能上传xlsx文件!</div>
			  </el-upload>
		  </div>
		  <div><el-button size="small" type="success" @click="downLoadMode1">下载导入模板</el-button></div>
	  </div>
	</el-dialog>
	<!-- 上下画照片查看弹框 -->
	<img-dialog ref="imgDialog"></img-dialog>
    <!-- 价审、锁位弹框 -->
    <jssw :action="action" @onjssw="onjssw" ref="jsswDialog" :nametitle="nameState"></jssw>
    <!-- 查看更多弹框 -->
    <order-more @orderPointImg="onPointImg" @orderPoint="onOrderPoint" :tableData="moreTabData" ref="moreDialog"></order-more>
	<!-- 查看切换点位 -->
	<change-point :tableData="changeTabData" ref="changePDialog"></change-point>
	<order-point ref="refPoint" @onPoint="onPoint"></order-point>
  </div>
</template>

<script>
import imgDialog from "../../components/dialog/order/imgDialog.vue"
import orderMore from "../../components/dialog/order/offer.vue";
import changePoint from "../../components/dialog/order/changePoint.vue";
import jssw from "../../components/dialog/order/jssw.vue";
import orderPoint from "../../components/dialog/orderPoint.vue";
export default {
  components: {
    jssw,
    orderMore,
	orderPoint,
	changePoint,
	imgDialog
  },
  data() {
    return {
		fileList:[],
		zydialogVisible:false,
		kzdialogVisible:false,
		cType:'',
		fullscreenLoading:false,
		action:'',
		action2:'',
		action3:'',
		stateObj:{},
		nameState:'',
		moreTabData:[],
		changeTabData:[],
		param:{},
      value1: "",
      tableData: [
        // {
        //   name: '大虎\u3000\u3000\u3000小虎',
        // },
        // {
        //   name: "王小虎1",
        //   img: "https://cdn.uviewui.com/uview/album/1.jpg",
        //   name1: "111",
        //   name2: "22222",
        //   name3: "33333",
        //   name4: "444444",
        //   name6: "价审",
        // },
      ],
	  pageObj: {
	  	limit: 10,
	  	page: 1,
		brand:'',
		filter: {},
		op: {}
	  },
	  total: 0, //总条数
      multipleSelection: [], //勾选的数据
      currentPage: 1, //当前页
      loading: true, //是否显示加载中图
	  uploading:{},//上传文件时加载
      searchVal: "", //搜索框值
      kqTabData:[
          {name:'序号',prop:'date'},
          {name:'新编号',prop:'name'},
          {name:'级别',prop:'date'},
          {name:'站点',prop:'date'},
          {name:'类型',prop:'date'},
          {name:'投放形式',prop:'date'},
      ]
    };
  },
  created() {
	this.action = this.$baseUrl + '/admin/ajax/upload?PHPSESSID='+this.getCookie('PHPSESSID')  
	this.action2 = this.$baseUrl + '/admin/order/importOrder?PHPSESSID='+this.getCookie('PHPSESSID') 
	this.action3 = this.$baseUrl + '/admin/Order/importOriginalOrder?PHPSESSID='+this.getCookie('PHPSESSID') 
    this.getList();
  },
  methods: {
	  onProgress(event, file, fileList){
		this.uploading = this.$loading({
			lock: true,
			text: '上传文件处理中，请耐心等待...',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		});
	  },
	  onSuccess(response,file, fileList){
		  if(response.code == 1){
			  this.$message.success(response.msg)
			  this.uploading.close();
		  }else{
			  this.$message.error(response.msg)
		  }
	  },
	  beforeUpload(file){
		  console.log(file);
		  let type = file.name.substring(file.name.lastIndexOf(".")+1)
		  if(type != 'xlsx'){
			  this.$message.error(`上传文件必须为xlsx格式`,3000);
			  return false;
		  }
	  },
	   handleRemove(file, fileList) {
		  console.log(file, fileList);
		},
		handlePreview(file) {
		  console.log(file);
		},
		handleExceed(files, fileList) {
		  this.$message.warning(`限制上传1个文件`);
		},
		beforeRemove(file, fileList) {
		  // return this.$confirm(`确定移除 ${ file.name }？`);
		},
	  // 预览图片
	  showAllImg(item){
		  // this.$api2.getAdvertiseIds({id:item.id,type:1}).then((res)=>{
			 //  if(res.code == 1){
				//   this.showImgList = res.data
			 //  }
		  // })
	  },
	  //查看切换点位
	  lookChangeP(item){
		  this.changeTabData = item.switch_log ;
		  this.$refs.changePDialog.dialogVisible = true;
	  },
	  downLoadMode(){
		  window.open(this.$baseUrl + '/excel/t.xlsx')
	  },
	  downLoadMode1(){
		  window.open(this.$baseUrl + '/excel/t1.xlsx')
	  },
	  // 下载上下画照片
	  handleDImg(id,type){
		  let api = this.$baseUrl + '/admin/order/downloadPushlist'
		  let sesion = this.getCookie('PHPSESSID')  
		  if(type == 3){
			  // location.href = this.$baseUrl + '/admin/order/downloadPainted' + `?id=${id}&PHPSESSID=${sesion}`
			  window.open(this.$baseUrl + '/admin/order/downloadPainted' + `?id=${id}&PHPSESSID=${sesion}`)
			  return
		  }
		  if(type == 4){
			  window.open(this.$baseUrl + '/admin/order/downloadSmall' + `?id=${id}&PHPSESSID=${sesion}`)
			  return
		  }
		  if(type == 5){
			  window.open(this.$baseUrl + '/admin/order/downloadBasis' + `?id=${id}&PHPSESSID=${sesion}`)
			  return
		  }
		  if(type == 6){
			  window.open(this.$baseUrl + '/admin/order/downloadAllBasis' + `?PHPSESSID=${sesion}`)
		  }
		// location.href = api + `?id=${id}&type=${type}&PHPSESSID=${sesion}`
		window.open(api + `?id=${id}&type=${type}&PHPSESSID=${sesion}`); 
	  },
	  onPointImg(e){
		this.$refs.imgDialog.title = e.type == 1 ? '上画照片' : '下画照片'
		e.id = this.param.id
		console.log(e);
		this.$api2.getPushlish(e).then((res)=>{
			if(res.code == 1){
				this.$refs.imgDialog.imgUrl = res.data
				this.$refs.imgDialog.dialogVisible = true;
				// this.$refs.refPoint.dialogVisible = false
				// this.$refs.moreDialog.dialogVisible = false;
			}else{
				this.$message.error(res.msg)
			}
		})
	  },
	  onPoint(e){
		// console.log(e);  
		this.param.new_number = e.new_number;
		this.$api2.switchAdvertise(this.param).then((res)=>{
			if(res.code == 1){
				this.getList()
				this.$refs.refPoint.dialogVisible = false
				this.$refs.moreDialog.dialogVisible = false;
				this.$message.success(res.msg)
			}else{
				this.$message.error(res.msg)
			}
			
		})
	  },
	  onOrderPoint(e){
		  this.param.advertise_id = e
		this.$refs.refPoint.dialogVisible = true;
	  },
	  //支付
	  handlePay(v){
		  this.$confirm('是否支付金额：'+v.price+' ？', '提示').then(() => {
			  this.stateObj.id = v.id
			  this.stateObj.field = 'pay'
			  this.stateObj.value = 1
		  	this.$api2.modifyOrder(this.stateObj).then((res)=>{
		  		if(res.code == 1){
		  			this.$message.success(res.msg)
		  			this.getList()
		  		}else{
		  			this.$message.error(res.msg)
		  		}
		  	})
		  }).catch(()=>{})
	  },
	  changeDate(e){
		  // console.log(this.searchObj.date);
		  this.pageObj.start_time = this.value1[0]
		  this.pageObj.end_time = this.value1[1]
  },
  // 价审,锁位,投放
    onjssw(e) {
		let apiName = ''
		if(this.cType == 0){
			apiName = 'modifyOrder'
		}else if(this.cType == 1){
			apiName = 'modifyOrderPay'
		}else{
			apiName = 'modifyOrderPut'
		}
		//投放情况
		if(!this.nameState){
			this.stateObj.put_images = e
			this.stateObj.value = 3
		}
		this.$api2[apiName](this.stateObj).then((res)=>{
			if(res.code == 1){
				this.$refs.jsswDialog.dialogVisible = false;
				this.$message.success(res.msg)
				this.getList()
			}else{
				this.$message.error(res.msg)
			}
		})
	},
    //查看更多弹框
    lookAll(item) {
		this.loading = true;
		this.$api2.getMoreAdvertise({id:item.id}).then((res)=>{
			this.loading = false;
			if(res.code == 1){
				this.$refs.moreDialog.type = 1;
				this.moreTabData = res.data;
				// this.$refs.moreDialog.id = item.id //订单id
				this.param.id = item.id //订单id
				this.$refs.moreDialog.order_status = item.order_status.value; //价审/锁位/投放画面 状态
				this.$refs.moreDialog.dialogVisible = true;
			}else{
				this.$message.error(res.msg)
			}
		})
    },
    //价审、锁位弹框
    jssw(item,type,name) {
		this.cType = type;
		this.stateObj.field = 'order_status'
		if(type == 2){
			this.loading = true;
			this.$api2.getAdvertiseIds({id:item.id}).then((res)=>{
				if(res.code == 1){
					this.$refs.jsswDialog.imgObj.fileList = []
					this.$refs.jsswDialog.imgarr = []
					res.data.forEach((v,k)=>{
						this.$refs.jsswDialog.imgObj.fileList[k] = {
							// id:v.value,
							url:v.put_images_url,
							type:v.type,
							uid:v.put_images_value,
							// urlObj:v.put_images_url?[{url:v.put_images_url}]:[],
							text:v.text
						}
						this.$refs.jsswDialog.imgarr[k] = {
							// id:v.value,
							url:v.put_images_url,
							type:v.type,
							uid:v.put_images_value,
							// urlObj:v.put_images_url?[{url:v.put_images_url}]:[],
							// flag:!v.put_images_url?true:false,
							text:v.text
						}
					})
					this.loading = false;
					this.$refs.jsswDialog.dialogVisible = true;
				}else{
					this.loading = false;
					this.$message.error(res.msg)
				}
			})
		}else{
			this.$refs.jsswDialog.price = item.price;
			this.$refs.jsswDialog.dialogVisible = true;
		}
		this.nameState = name //弹框文字
		if(type != 3){
			type ++;
		}
		this.stateObj.id = item.id
		this.stateObj.value = type
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex % 2 === 0) {
        if (columnIndex === 0) {
          return [0, 0];
        } else if (columnIndex === 1) {
          return [1, 10];
        }
      }
    },
    //解锁
    onUnlock() {
      if (!this.multipleSelection.length) return this.$message.error("请勾选要解锁的选项！");
	  let ids = []
	  this.multipleSelection.forEach((v,k)=>{
	  	ids[k] = v.id
	  })
	  this.$confirm('确认解锁？', '提示').then(() => {
	  	this.$api2.unlock({id:ids}).then((res)=>{
	  		if(res.code == 1){
	  			this.$message.success(res.msg)
	  			this.getList()
	  		}else{
	  			this.$message.error(res.msg)
	  		}
	  	})
	  }).catch(()=>{})
    },
    //搜索
    onSearch() {
		this.pageObj.page = 1
		this.pageObj.filter.order_no = this.searchVal;
		// this.pageObj.op.brand = '%*%'
		this.pageObj.op.order_no = '='
		this.getList()
	},
    //删除
    onDel() {
      if (!this.multipleSelection.length) return this.$message.error("请勾选要删除的选项！");
	  let ids = []
	  this.multipleSelection.forEach((v,k)=>{
	  	ids[k] = v.id
	  })
	  this.$confirm('确认作废？', '提示').then(() => {
	  	this.$api2.deleteOrder({id:ids}).then((res)=>{
	  		if(res.code == 1){
	  			this.$message.success(res.msg)
	  			this.getList()
	  		}else{
	  			this.$message.error(res.msg)
	  		}
	  	})
	  }).catch(()=>{})
    },
    // 获取数据列表
    getList() {
		this.loading = true;
     this.$api2.orderList(this.pageObj).then(res => {
     	this.loading = false;
     	if (res.code == 1) {
     		this.total = res.count;
			res.data.forEach((v,k)=>{
				if(v.flag){
					res.data[k].imgList = []
					v.advertise_ids.forEach((vv,kk)=>{
						if(vv.put_images_url){
							res.data[k].imgList.push(vv.put_images_url)
						}
					})
				}
			})
     		this.tableData = res.data;
			console.log(res.data);
     	}
     })
     .catch(err => {
     	this.loading = false;
     });
    },
	// 获取cookie
	getCookie(name) {
	 var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	 if (arr = document.cookie.match(reg))
	  return (arr[2]);
	 else
	  return null;
	},
    // 多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
	  this.pageObj.limit = val;
	  this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
	  this.pageObj.page = val;
	  this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/public.scss";
.row1 {
  align-items: center;
  justify-content: space-between;
}
.search {
  margin-left: 20px !important;
  margin-right: 0 !important;
}
.handle-box {
  padding: 0 10px;
  // display: flex;
  // justify-content: space-around;
}
//    /dedp/  解决scoped中组件样式不生效
.tab-box /deep/ {
  .has-gutter .cell {
    text-align: center !important;
  }
  .has-gutter .el-table__cell {
    background-color: red;
    border: none !important;
  }
  .el-table__row:nth-child(2n) {
    margin-bottom: 20px;
    .el-table_1_column_1 {
      border-right: none!important;
    }
    .cell {
      text-align: center !important;
    }
  }
  .el-table__row:nth-child(2n - 1) {
    text-align: left !important;
    .cell {
      line-height: 5px;
      padding-left: 30px !important;
    }
  }
  .el-table__cell:nth-child(2n-1) {
    text-align: left !important;
  }
}
</style>